module.exports = __webpack_public_path__ + "img/about_product_icon.1672969f.png";